import { useMemo } from 'react'

import clsx from 'clsx'
import { UNDER_CONSTRUCTION_EMPTY_STATE_DARK, UNDER_CONSTRUCTION_EMPTY_STATE } from 'src/assets'
import { ThemeMode, useTheme } from 'src/lib/contexts'

import ErrorBoundary from './errorBoundary'
import styles from './errorBoundary.module.css'
import type { ErrorBoundaryContainerProps } from './types'

const ErrorBoundaryContainer = ({ children }: ErrorBoundaryContainerProps): JSX.Element => {
  const { theme } = useTheme()

  const imgSrc = useMemo(() => {
    return theme === ThemeMode.DARK
      ? UNDER_CONSTRUCTION_EMPTY_STATE_DARK
      : UNDER_CONSTRUCTION_EMPTY_STATE
  }, [theme])

  return (
    <div
      className={clsx(styles.box, {
        [styles.dark]: theme === ThemeMode.DARK
      })}>
      <ErrorBoundary imgSrc={imgSrc}>{children}</ErrorBoundary>
    </div>
  )
}

export default ErrorBoundaryContainer
